/**
 * Выполнять функцию не чаще заданного интервала
 * 
 * @param func Исходная функция
 * @param threshold Минимальный интервал между вызовами
 * @returns Функция с ограницением по вызовам
 */
// tslint:disable-next-line:ban-types
function throttle<T extends Function>(
	func: T,
	threshold: number = 100,
): T
{
	let timerId: number;
	let lastExecutionTime: number;
	
	return function throttled( this: any, ...rest: any[] ): void
	{
		const currentTime = Date.now();
		
		if ( lastExecutionTime
			&& ( currentTime < lastExecutionTime + threshold ) )
		{
			clearTimeout( timerId );
			timerId = setTimeout(
				() =>
				{
					lastExecutionTime = currentTime;
					func.apply( this, rest );
				},
				threshold,
			);
		}
		else
		{
			lastExecutionTime = currentTime;
			func.apply( this, rest );
		}
	} as any;
}

/**
 * Module
 */
export {
	throttle as default,
};



// WEBPACK FOOTER //
// ./utils/events/throttle.ts